import React, { useEffect } from "react";

import Main from '../components/CompositeMesh/Main'
import Projects from "../components/Home/Projects";
import Liam from "../components/Home/Liam";
import WhyWait from "../components/Home/WhyWait";
import Customizable from "../components/CompositeMesh/Customizable";
import CustomizableDimensions from "../components/CompositeMesh/CustomizableDimensions";
import Physical from "../components/CompositeMesh/Physical";
import ContactUs from "../components/CompositeMesh/ContactUs";
import MeshThick from "../components/MansoryMesh/MeshThick";
import WhyComposite from "../components/CompositeMesh/WhyComposite";
import AdvantagesOfCompositeMesh from "../components/CompositeMesh/AdvantagesOfCompositeMesh";
import AreasApplicationComposite from "../components/CompositeMesh/AreasApplicationComposite";

function CompositeMesh () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#1D1D1D] relative overflow-hidden">
            <Main/>
            {/* <Customizable/> */}
            <CustomizableDimensions/>
            <MeshThick/>
            <WhyComposite/>
            <Physical/>
            <AdvantagesOfCompositeMesh/>
            <AreasApplicationComposite/>
            <ContactUs/>
            <Projects/>
            {/* <Liam/>
            <WhyWait/> */}
        </div>
    );
}

export default CompositeMesh;